module.exports = {
    methods: {
        update(stats){
            this.model.stats = stats

            if((this.$ || {}).length > 0){
                this.refresh()
            }
        }
    }
}